import React from "react";
import Logo from '../assets/Logo color.png'
export default function Footer() {
  return (
    <div className=" bg-white text-black flex items-center justify-between lg:flex-row flex-col lg:p-9 p-20">
      <img src={Logo} alt="" />{" "}
      <ul className="flex justify-between items-center w-[35%] lg:gap-0 gap-10 lg:flex-row flex-col lg:mt-0 mt-20">
        <li className="text-nowrap">Privacy Policy</li>
        <li className="text-nowrap"> Terms and Conditions</li>
        <li className="text-nowrap"> Contact Us</li>
        <li className="text-nowrap">Careers</li>
      </ul>
    </div>
  );
}
